<script setup>
import { useI18n } from 'vue-i18n';
import { RECITERS } from '@/utils/quran/audio';

const model = defineModel({ type: String, required: true });
defineProps({ tone: { type: String, default: 'dark' } });

const { t } = useI18n();
</script>

<template>
  <fieldset>
    <legend class="text-[10px] font-bold uppercase tracking-widest mb-2" :class="tone === 'dark' ? 'text-white/40' : 'text-deen-ink/40'">
      {{ t('quran.player.reciter') }}
    </legend>
    <div class="grid gap-1">
      <label
        v-for="reciter in RECITERS"
        :key="reciter.id"
        :class="[
          'flex items-center justify-between gap-3 px-3 py-2.5 rounded-xl cursor-pointer text-sm font-semibold transition-colors',
          tone === 'dark'
            ? model === reciter.id ? 'bg-white/15 text-white' : 'text-white/70 hover:bg-white/5'
            : model === reciter.id ? 'bg-deen-ink text-white' : 'text-deen-ink/70 hover:bg-deen-ink/5',
        ]"
      >
        <input v-model="model" type="radio" name="reciter" :value="reciter.id" class="sr-only" />
        <span>{{ reciter.name }}</span>
        <iconify-icon v-if="model === reciter.id" icon="solar:check-circle-bold" class="text-deen-gold text-lg" aria-hidden="true" />
      </label>
    </div>
  </fieldset>
</template>
